module.exports = __webpack_public_path__ + "img/aeroland-client-logo-08-hover.419cd5a9.png";